import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem, darken, rgba } from 'polished';
import { Link } from 'react-router';
import { __ } from 'react-i18n/lib';
import {
  FlexRowCenterVertical,
  FlexColCenter,
  Flexbox,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { prop, getSymbolFromCurrency } from '../../../utilities';
import {
  getSearchProductInfo,
  getSearchCategoryInfo,
  getArticleDefaultInfo,
} from '../../../utilities/selectors';
import { Loader } from '../General/Loader';
import { ProductSearchItem } from '../Product/ProductSearchItem';
import { getZlataPriadkaProductDefaultInfo } from '../selectors';
interface SearchResultsViewerProps {
  visible: boolean;
  searchResults: {
    productsResult: any;
    categoriesResult: any;
  };
  searchTerm: string;
  redirectToResultPage: (e, type?: string) => void;
  hideResultViewer: (e) => void;
  innerRef?: any;
  partialSearchProductsIsFetching: boolean;
  partialSearchCategoriesIsFetching: boolean;
  partialSearchArticlesIsFetching: boolean;
  user: any;
  partialSearchCategoryProducts?: any;
}

const SearchDropdown = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  background: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.textPrimary};

  /* max-width: ${({ theme }) => `${theme.grid.container.base}px`}; */
  /* width: 100%; */
  margin: 0 auto;
  z-index: 50;
  margin-left: ${rem(-28)};
  margin-right: ${rem(-28)};

  ${({ theme }) => theme.mediab.l1050`
    margin-left: 0;
    margin-right: 0;
  `}

  ${({ theme }) => theme.mediab.m810`
    flex-direction: column;
  `}
`;

const LeftSection = styled.div`
  display: block;
  flex: 1 1 50%;
`;

const RightSection = styled.div`
  display: flex;
  flex: 1 1 50%;
  flex-direction: column;
  padding-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.m810`
    padding-bottom: 0;
  `}
`;

const NoResultsSearchDropdown = styled(SearchDropdown)`
  padding: ${rem(24)};
`;

const DropdownSection = styled.div`
  padding: ${rem(32)} ${rem(28)} ${rem(8)};

  ${({ theme }) => theme.mediab.m810`
    padding-left: ${rem(16)};
    padding-right: ${rem(16)};
    padding-bottom: 0;
  `}
`;

const ProductDropdownSection = styled(DropdownSection)`
  padding-top: ${rem(32)};
  padding-bottom: ${rem(32)};

  ${({ theme }) => theme.mediab.m810`
    padding-bottom: 0;
  `}
`;

const DropdownTitle = styled.p`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  font-weight: 500;
  margin: 0;
  padding-bottom: ${rem(18)};
`;

const showMoreButtonLikeCss = css`
  font-size: ${rem(16)};
  line-height: ${rem(19)};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 600;
  padding: ${rem(15)};
  background: ${({ theme }) => theme.colors.primary};
  border-radius: ${rem(4)};
  outline: none;
  border: none;
  display: block;
  width: 100%;
  text-align: center;
  margin-top: ${rem(32)};
  cursor: pointer;
`;

const ShowMoreProductsDesktop = styled.button`
  ${showMoreButtonLikeCss};
  display: block;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const ShowMoreProductsMobile = styled.button`
  ${showMoreButtonLikeCss};
  display: none;
  margin: ${rem(40)} ${rem(16)} ${rem(32)};
  width: initial;

  ${({ theme }) => theme.mediab.m810`
    display: block;
  `}
`;

const DropdownName = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 300;
`;

const DropdownItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: ${rem(31)};
  line-height: ${rem(21)};

  &:hover > ${DropdownName} {
    text-decoration: underline;
  }
`;

const NumberOfProducts = styled(TextP)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.placeholder};
`;

const HighlightedText = styled.span`
  /* background-color: ${({ theme }) => rgba(theme.colors.highlight, 0.32)}; */
  background: transparent;
`;

const Bold = styled.span`
  font-weight: 400;
  font-size: ${rem(18)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
`;

const ProductTitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  border-bottom: ${rem(2)} solid #eeeeee;
`;

const NoResults = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-top: ${rem(14)};
  word-break: break-word;
`;

const ProductResultsWrapper = styled(FlexColCenter)`
  padding-top: ${rem(16)};
`;

const CategoryArticlesResultsWrapper = styled.div`
  padding-top: ${rem(20)};
`;

const LastParent = styled.span`
  color: ${({ theme }) => theme.colors.black};
`;
class SearchResultsViewer extends React.Component<SearchResultsViewerProps> {
  public render() {
    const {
      visible,
      partialSearchProductsIsFetching,
      partialSearchCategoriesIsFetching,
      partialSearchArticlesIsFetching,
      searchResults,
      innerRef,
      searchTerm,
      partialSearchCategoryProducts,
    } = this.props;

    if (searchTerm.length < 2) {
      return null;
    }
    const productsResult = prop(searchResults, 'productsResult', null);
    const correctProductResults =
      productsResult &&
      productsResult.products &&
      productsResult.products.length > 0
        ? productsResult.products
        : partialSearchCategoryProducts
        ? partialSearchCategoryProducts.products
        : [];
    const categories = prop(searchResults, 'categoriesResult', []);
    const onlyTopTwoCat = categories && categories.slice(0, 2);

    const articles = prop(searchResults, 'articlesResult', []);
    const onlyTopTwoArticles = articles && articles.slice(0, 2);

    if (
      !partialSearchProductsIsFetching &&
      !partialSearchCategoriesIsFetching &&
      !partialSearchArticlesIsFetching &&
      (!onlyTopTwoCat || onlyTopTwoCat.length === 0) &&
      (!productsResult ||
        !productsResult.products ||
        (productsResult &&
          productsResult.products &&
          productsResult.products.length === 0))
    ) {
      return (
        <NoResultsSearchDropdown visible={visible}>
          <DropdownSection>
            <Bold>{__('Žiadne dostupné výsledky vyhľadávania')}...</Bold>
          </DropdownSection>
        </NoResultsSearchDropdown>
      );
    }

    return (
      <SearchDropdown visible={visible} innerRef={innerRef}>
        {correctProductResults && correctProductResults.length > 0 && (
          <LeftSection>
            <ProductDropdownSection>
              <ProductTitleWrapper>
                <DropdownTitle>{__('Produkty')}</DropdownTitle>
              </ProductTitleWrapper>
              {this.printProductResults(correctProductResults)}
              <ShowMoreProductsDesktop onClick={this.redirectToMoreProducts}>
                {__('Zobraziť viac')}
              </ShowMoreProductsDesktop>
            </ProductDropdownSection>
          </LeftSection>
        )}

        {((onlyTopTwoCat && onlyTopTwoCat.length > 0) ||
          (onlyTopTwoArticles && onlyTopTwoArticles.length > 0)) && (
          <RightSection>
            {onlyTopTwoCat && onlyTopTwoCat.length > 0 && (
              <DropdownSection>
                <ProductTitleWrapper>
                  <DropdownTitle>{__('Ponuka tovaru')}</DropdownTitle>
                </ProductTitleWrapper>
                {this.printCategoriesResults()}
              </DropdownSection>
            )}

            {onlyTopTwoArticles && onlyTopTwoArticles.length > 0 && (
              <DropdownSection>
                <ProductTitleWrapper>
                  <DropdownTitle>{__('Blog')}</DropdownTitle>
                </ProductTitleWrapper>
                {this.printArticlesResults()}
              </DropdownSection>
            )}
          </RightSection>
        )}

        {((correctProductResults && correctProductResults.length > 0) ||
          (onlyTopTwoCat && onlyTopTwoCat.length > 0) ||
          (onlyTopTwoArticles && onlyTopTwoArticles.length > 0)) && (
          <ShowMoreProductsMobile onClick={this.redirectToMoreProducts}>
            {__('Zobraziť viac')}
          </ShowMoreProductsMobile>
        )}
      </SearchDropdown>
    );
  }

  private redirectToMoreCategories = e => {
    this.props.redirectToResultPage(e, 'categories');
  };

  private redirectToMoreProducts = e => {
    this.props.redirectToResultPage(e, 'products');
  };

  private printCategoriesResults = () => {
    const {
      searchTerm,
      partialSearchCategoriesIsFetching,
      searchResults,
      hideResultViewer,
    } = this.props;

    if (partialSearchCategoriesIsFetching) {
      return <Loader small={true} />;
    }

    const categories = prop(searchResults, 'categoriesResult', []);
    const onlyTopTwoCat = categories;

    return (
      <CategoryArticlesResultsWrapper>
        {onlyTopTwoCat &&
          onlyTopTwoCat.map(category => {
            const { name, url, id, counts, lastParent } = getSearchCategoryInfo(
              category,
            );
            const numOfProducts = counts;
            const parts = name.split(new RegExp(`(${searchTerm})`, 'gi'));

            return (
              <DropdownItem onClick={hideResultViewer} to={`/${url}`} key={id}>
                <DropdownName>
                  <LastParent>
                    {lastParent ? `${lastParent.category_name}  /  ` : ''}
                  </LastParent>
                  {parts &&
                    parts.map((part, i) =>
                      part.toLowerCase() === searchTerm.toLowerCase() ? (
                        <HighlightedText key={i}>{part}</HighlightedText>
                      ) : (
                        part
                      ),
                    )}
                </DropdownName>
              </DropdownItem>
            );
          })}
      </CategoryArticlesResultsWrapper>
    );
  };

  private printArticlesResults = () => {
    const {
      searchTerm,
      partialSearchArticlesIsFetching,
      searchResults,
      hideResultViewer,
    } = this.props;

    if (partialSearchArticlesIsFetching) {
      return <Loader small={true} />;
    }

    const articles = prop(searchResults, 'articlesResult', []);
    const onlyTopTwoArticles = articles && articles.slice(0, 2);

    return (
      <CategoryArticlesResultsWrapper>
        {onlyTopTwoArticles &&
          onlyTopTwoArticles.map((article, index) => {
            const { title, url } = getArticleDefaultInfo(article);
            const parts = title.split(new RegExp(`(${searchTerm})`, 'gi'));

            return (
              <DropdownItem onClick={hideResultViewer} to={url} key={index}>
                <DropdownName>
                  {parts &&
                    parts.map((part, i) =>
                      part.toLowerCase() === searchTerm.toLowerCase() ? (
                        <HighlightedText key={i}>{part}</HighlightedText>
                      ) : (
                        part
                      ),
                    )}
                </DropdownName>
              </DropdownItem>
            );
          })}
      </CategoryArticlesResultsWrapper>
    );
  };

  private printProductResults = products => {
    const {
      searchTerm,
      searchResults,
      partialSearchProductsIsFetching,
      hideResultViewer,
      user,
    } = this.props;

    if (partialSearchProductsIsFetching) {
      return <Loader small={true} />;
    }

    return (
      <ProductResultsWrapper>
        {products.length !== 0 ? (
          <>
            {products.map(product => {
              const { id, picture, url, name, currency } = getSearchProductInfo(
                product,
                'main_good',
              );
              const {
                unit,
                price,
                priceWithoutVat,
                statusB2B,
                statusB2C,
              } = getZlataPriadkaProductDefaultInfo(product, 'main_good');
              const isB2B = user && user.b2b;
              const statusShowPrice = isB2B ? statusB2B !== 3 : statusB2C !== 3;
              const correctPrice = statusShowPrice
                ? isB2B
                  ? (+priceWithoutVat).toFixed(2)
                  : (+price).toFixed(2)
                : '';

              return (
                <ProductSearchItem
                  onClick={hideResultViewer}
                  searchTerm={searchTerm}
                  url={url}
                  name={name}
                  currency={getSymbolFromCurrency(currency)}
                  price={correctPrice}
                  key={id}
                  imgSrc={picture}
                  unit={unit}
                />
              );
            })}
          </>
        ) : (
          <NoResults>{`${__('Pre výraz')}: "${searchTerm}" ${__(
            'sa nenašli žiadne výsledky',
          )}`}</NoResults>
        )}
      </ProductResultsWrapper>
    );
  };
}

export { SearchResultsViewer };
